module.exports = __webpack_public_path__ + "img/Schnute.43a1cccc.svg";